{
  "action": "Action: ",
  "actionName": "Action",
  "activeDatesLabel": "Active Dates",
  "activeDatesValueWithStartAndEnd": "{{start, datetime}} - {{end, datetime}}",
  "activeDatesWithStart": "{{start, datetime}}",
  "cancel": "Cancel",
  "datetimeWithVal": "{{val, datetime}}",
  "delete": "Delete",
  "deleteThisSchedule": "Delete this schedule?",
  "endTimeLabel": "End",
  "executeAt": "Execute At",
  "executeAtWithTimestamp": "{{timestamp, datetime}}",
  "executeOnceOn": "Execute Once On:",
  "executeOnceOnWithDate": "Execute once on {{val, datetime}}",
  "executionTime": "Execution Time",
  "executionWithStartAndEnd": "{{start, datetime}}  -  {{end, datetime}}",
  "executionWithStartAndEndAndTimezone": "{{start, datetime}}  -  {{end, datetime}} {{timezone}}",
  "executionWithStartAndEndAndTimezoneNextDay": "{{start, datetime}}  -  {{end, datetime}} {{timezone}} (Next Day)",
  "executionWithStartAndEndNextDay": "{{start, datetime}}  -  {{end, datetime}} (Next Day)",
  "executionWithStartNextDay": "{{start, datetime}} (Next Day)",
  "helpBody": "Schedules are used to turn on and off pumps or valves at specific times or for specific durations. Schedules can be set to run once or to repeat on specific days of the week.\n\nSchedules need to sync to devices to work properly, which should happen quickly, but not immediately. If you don't see your schedule running when you expect it to, please check the sync status. If the sync status is 'Sync failed', please contact FarmHQ support.",
  "helpTitle": "About Schedules",
  "manageScheduleTitle": "Manage Schedule",
  "new": "New",
  "nextDayParentheses": "(Next Day)",
  "nextScheduleActionWithTimestamp": "Next action scheduled at {{timestamp, datetime}}",
  "noSchedules": "No Scheduled Actions found for your farm account.",
  "noSchedulesActive": "No active schedules found.",
  "noSchedulesExpired": "No past scheduled actions found.",
  "repeatWeeklyOnDays": "Repeat Weekly on Days:",
  "repeats": "Repeats: ",
  "scheduledActions": "Scheduled Actions",
  "schedulesActiveTitle": "Active Schedules",
  "schedulesExpiredTitle": "Expired Schedules",
  "schedulesListTitle": "Irrigation Schedules",
  "startTimeLabel": "Start",
  "status": "Status",
  "syncStatus_FAILED": "Sync failed. Please contact support.",
  "syncStatus_IN_PROGRESS": "Syncing to device...",
  "syncStatus_SUCCESS": "Synced to device.",
  "theFollowingScheduledActionWillBeCancelled": "The following scheduled action will be canceled.",
  "thisWeek": "This Week:",
  "time": "Time",
  "upcomingActionsTitle": "Upcoming Scheduled Actions",
  "upcomingActionExecuteAt": "Scheduled for {{timestamp, datetime}}",
  "upcomingActionCancelConfirm": "Cancel this action?",
  "upcomingActionCancelButton": "Cancel Action",
  "upcomingActionsEmpty": "No upcoming actions scheduled."
}
